var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8727_1686)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8727_1686",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8727_1686)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8727_1686",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8727_1686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8727_1686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8933 16.9922C14.1888 16.9922 13.4847 16.608 13.1035 15.9582L10.4628 11.2622L7.82257 15.9586C7.2653 16.963 6.00359 17.2877 5.03549 16.7267C4.0378 16.1653 3.71535 14.8953 4.27262 13.9205L8.64423 6.0345C9.02548 5.41432 9.70034 5.00049 10.434 5.00049C11.1673 5.00049 11.8421 5.41394 12.2238 6.0345L16.6534 13.8909C17.2107 14.895 16.8587 16.1357 15.8906 16.6967C15.5681 16.9038 15.2161 16.9922 14.8933 16.9922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 16.9921H14.8926V11.6756C14.8926 10.5232 15.8023 9.60791 16.9464 9.60791C18.0905 9.60791 18.9998 10.5236 18.9998 11.6756V16.9921H19.0002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9464 9.1353C18.0804 9.1353 18.9998 8.20952 18.9998 7.06765C18.9998 5.92578 18.0804 5 16.9464 5C15.812 5 14.8926 5.92578 14.8926 7.06765C14.8926 8.20952 15.812 9.1353 16.9464 9.1353Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8727_1686",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8727_1686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.b25ad9f888a8346cb6a29e0457569f9b.svg";
export { ForwardRef as ReactComponent };